import {
	UPDATE_AUTOSKIP,
	UPDATE_AMOUNT,
	SELECT_DEFAULT_AMOUNT,
	SHOW_DEPOSIT_LIMIT_OPTION
} from '@comeon/actions-public';
import { getFeesAndLimits } from '../../../../ducks/index.js';
import { updatePaymentStatusSpec } from '../../../../ducks/payment.js';

function updateAmount(payload) {
	return dispatch => {
		dispatch({
			type: UPDATE_AMOUNT,
			payload
		});
		return dispatch(getFeesAndLimits(payload));
	};
}
function updateAmountFromDefaultDeposit() {
	return (dispatch, getState) => {
		const { selected } = getState().payment.defaultDepositAmountsFormatted;
		const amount =
			getState().payment.defaultDepositAmountsFormatted[selected] &&
			getState().payment.defaultDepositAmountsFormatted[selected].value;
		dispatch({
			type: SELECT_DEFAULT_AMOUNT,
			payload: {
				defaultDepositAmountsFormatted: {
					pending: false
				}
			}
		});
		return dispatch(updateAmount(amount));
	};
}
function selectDefaultDeposit(payload) {
	return dispatch => {
		dispatch({
			type: SELECT_DEFAULT_AMOUNT,
			payload: {
				defaultDepositAmountsFormatted: {
					selected: payload,
					pending: true
				}
			}
		});
	};
}
function updateAutoskip(payload) {
	return dispatch => {
		return dispatch({
			type: UPDATE_AUTOSKIP,
			payload: { status: payload }
		});
	};
}
function updateDepositLimitOption(payload) {
	return dispatch => {
		return dispatch({
			type: SHOW_DEPOSIT_LIMIT_OPTION,
			payload
		});
	};
}

// This method is used by the ui-component 'cvc-input'. Previously it used the
// action 'updatePaymentStatusSpec' directly, but it was then less clear what
// it did by insepction of the button-event-handler.
function updateCC(payload) {
	return dispatch => {
		return dispatch(updatePaymentStatusSpec(payload));
	};
}
// This method is used by the ui-component 'secureid-input'. Previously it used the
// action 'updatePaymentStatusSpec' directly, but it was then less clear what
// it did by insepction of the button-event-handler.
function updateSecureid(payload) {
	return dispatch => {
		return dispatch(updatePaymentStatusSpec(payload));
	};
}

function updateSwishPhoneNumber(payload) {
	return dispatch => {
		return dispatch(updatePaymentStatusSpec(payload));
	};
}

function updatePaypalBillingAggrDetails(payload = {}) {
	return dispatch => {
		return dispatch(updatePaymentStatusSpec(payload));
	};
}

function updateBankwireIndiaTrxId(payload) {
	return dispatch => {
		return dispatch(updatePaymentStatusSpec(payload));
	};
}

function updateTrustlyBank() {
	return dispatch => dispatch(updatePaymentStatusSpec({ changeBankAccount: true }));
}

function updateIdealBank() {
	return dispatch => dispatch(updatePaymentStatusSpec({ changeBankAccount: true }));
}

export {
	updateAmount,
	updateAmountFromDefaultDeposit,
	updatePaypalBillingAggrDetails,
	selectDefaultDeposit,
	updateAutoskip,
	updateDepositLimitOption,
	updateCC,
	updateSecureid,
	updateTrustlyBank,
	updateIdealBank,
	updateSwishPhoneNumber,
	updateBankwireIndiaTrxId
};
